/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2024-09-23 20:23:58
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\App.tsx
 * @Description: 
 */

import { setSystemTheme } from 'lancoo-web-ui';
import { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HashRouter, useRoutes } from 'react-router-dom';
import { schoolService } from './page/a_common/users';
import UserMaage from './page/userMaage';
import { service } from './page/userMaage/data';
import routes from './router';
import { selectSchoolId, setSchoolId, setSchoolInfo, setSchoolLevel } from './store/reducers/schoolInfo';
import { selectUserId, setLoginShow, setUserId, setUserInfo, setUserList } from './store/reducers/userInfo';
import { CommmonGet } from './util/network/api';
import { Spin } from 'antd';

// 创建上下文
const RouterContext = createContext<any | null>(null);

function App() {

  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);
  const schoolId = useSelector(selectSchoolId);

  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);

  const upUserInfo = () => {
    CommmonGet(service.getUserInfoForMobile + `?userId=${userId}`).then((res: any) => {
      // 登录成功后，获取用户信息

      if (res.data.length === 0 || !res.data) {
        // dispatch(setLoginShow(true));
        dispatch(setUserId(''));
        return;
      }
      var data = Array.isArray(res.data) ? res.data.find(ele => ele.userId == userId) : res.data
      dispatch(setUserInfo(data || {}));
      dispatch(setUserList(Array.isArray(res.data) ? res.data : [res.data]));
    })
  };

  const getSchoolInfo = () => {
    setIsloading(true);
    CommmonGet(schoolService.getSchoolInfo).then((res: any) => {
      const temp = res?.data?.[0];

      dispatch(setSchoolInfo(temp || {}));
      dispatch(setSchoolId(temp?.SchoolID || temp?.schoolId || ''));
      dispatch(setSchoolLevel(temp?.SchoolLevel || temp?.schoolLevel || ''));
    }).catch(error => {
      console.log(error);
    }).finally(() => setIsloading(false))
  }

  // 登录
  useEffect(() => {
    schoolId && userId && upUserInfo()
  }, [userId, schoolId]);

  useEffect(() => {
    dispatch(setLoginShow(false));
    // 皮肤值，1：智慧天堂 2：商务蓝天 3：蓝色海洋 4：绿意盎然 5：紫色星空6：红色中国
    setSystemTheme(2);
    getSchoolInfo();
  }, []);
  const GetRoutes = () => useRoutes(routes); // 一定要是函数内

  return (
    <div className='wjz_spin_div wjz_loding_spin'>
      <Spin spinning={isloading}>
        <HashRouter>
          <RouterContext.Provider value={{ upUserInfo }}>
            {schoolId && <GetRoutes />}
            {/* 登录 */}
            <UserMaage />
          </RouterContext.Provider>
        </HashRouter>
      </Spin>
    </div>
  );
}

export default App;
export { RouterContext };
